import { Button } from '@mui/material';
import React from 'react';
import { useAuth } from '../../hooks/use-auth.hook';
import { Link } from 'react-router-dom';

/**
 * Boutton qui est affiché suivant certaines conditions
 * @param props
 * @constructor
 */
export default function CustomButton(
    props: Readonly<{
        label: string;
        disabled?: boolean;
        type?: 'button' | 'submit' | 'reset';
        variant: 'text' | 'outlined' | 'contained' | 'neutral' | undefined;
        testId?: string;
        element?: JSX.Element;
        componentLink?: boolean;
        to?: string;
    }>
) {
    //Contexte d'auth
    const auth = useAuth();
    //Dans le cas de l'impressionnalisation on supprime les boutons
    if (props.type === 'submit' && auth.user?.emailLoggedInAS) {
        return <></>;
    }
    // retourne de bouton
    return props.componentLink && props.to ? (
        <Button
            data-testid={props.testId}
            disabled={props.disabled}
            component={Link}
            to={props.to}
            variant={props.variant}
        >
            {props.label}
        </Button>
    ) : (
        <Button type={props.type} variant={props.variant} data-testid={props.testId} disabled={props.disabled}>
            {props.label}
            {props.element}
        </Button>
    );
}
